import { render, staticRenderFns } from "./CreateContentBrechaOperacional.vue?vue&type=template&id=1296bbb9&scoped=true"
import script from "./CreateContentBrechaOperacional.vue?vue&type=script&lang=js"
export * from "./CreateContentBrechaOperacional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296bbb9",
  null
  
)

export default component.exports